// extracted by mini-css-extract-plugin
module.exports = {"dpu-calculator-step2-B":"B_dpu-calculator-step2-B__ohjC2"};